export default {
  LIST(state, data) {
    state.directionSectorCodes = data
  },
  UPDATE(state, value) {
    state.directionSectorCode = {
      id: value.id,
      direction: value.direction?.id ?? value.direction,
      category_subject: value.category_subject?.id ?? value.category_subject,
    }
  },
  FRESH(state) {
    state.directionSectorCode = {
      id: null,
      direction: null,
      category_subject: null,
    }
  },
  PREPARE_FOR_DIRECTION(state, directionId) {
    state.directionSectorCode = {
      id: null,
      direction: directionId,
      category_subject: null,
    }
  },
  GET(state, data) {
    state.directionSectorCode = data
  },
  SET_DIRECTIONS(state, data) {
    state.directions = data
  },
  SET_CATEGORY_SUBJECTS(state, data) {
    state.categorySubjects = data
  },
}
